export default __webpack_public_path__ + "static/media/serial-number.5a3517a0.jpg";